var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.ready)?_c('visits'):_vm._e(),_c('shortcodes'),_c('b-row',{staticClass:"match-height"},[_c('b-col',{attrs:{"lg":"6"}},[_c('channels')],1),_c('b-col',{attrs:{"lg":"6"}},[_c('referrers')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }